import axios from "axios";
import constants from "../config/consts.js";

class Api {
    constructor({ serverUrl }) {
        this._serverUrl = serverUrl;
        this._axios = axios.create({
            baseURL: serverUrl,
            withCredentials: true,
            headers: {
                'Content-Type': 'application/json',
            }
        });
    }

    async getLatestActiveProducts(limit = 9) {
        const res = await this._axios.get('/products/latest', { params: { limit } });
        return res.data;
    }

    async getProducts({ category, categories, type, sort, page = 1, limit = 6, isArch = false } = {}) {
        const params = { page, limit };
        if (categories && categories.length) {
            params.categories = categories.join(',');
        } else if (category) {
            params.category = category;
        }
        if (type && type !== 'all') params.type = type;
        if (sort) params.sort = sort;
        if (isArch) params.status = 'archive'
        const res = await this._axios.get('/products', { params });
        return res.data;
    }

    async getProductsByIds(ids) {
        const res = await this._axios.get('/products/byIds', { params: { ids: ids.join(',') } });
        return res.data;
    }

    async getProductById(id) {
        const res = await this._axios.get(`/products/${id}`);
        return res.data;
    }

    async createClientOrder(positions) {
        const res = await this._axios.post('/new_order', positions)        
        return res.data
    }
}

const API = new Api({
    serverUrl: constants.serverUrl
});

export default API;